import { render, staticRenderFns } from "./queryCount.vue?vue&type=template&id=1c10f518&scoped=true"
import script from "./queryCount.vue?vue&type=script&lang=js"
export * from "./queryCount.vue?vue&type=script&lang=js"
import style0 from "./queryCount.vue?vue&type=style&index=0&id=1c10f518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c10f518",
  null
  
)

export default component.exports